/* int-l4-vg-framed.js: moved from snippets/int-variant-gallery-framed.liquid (pdp-html-weight lever 4 batch 2, 2026-11-02). The Liquid values arrive in the JSON island #int-vgf-data. Do not edit here without the source note. */
(function () {
  if (window.__intVGFramedInit) return;
  window.__intVGFramedInit = true;

  var D = JSON.parse(document.getElementById('int-vgf-data').textContent);
  /* variantId -> its interior (featured_media) */
  var VAR_HERO = D.hero;
  /* every media id in product order — the triple is read off this */
  var MEDIA_ORDER = D.media;
  /* variantId -> Frame Size value (to preload the same-size colour siblings) */
  var VAR_SIZE = D.size;
  /* fallback only: media not assigned to any variant, first excluded (that one is the duplicate Searchanise hero, hidden on the PDP).
     Was a Liquid loop over hero_ids; the same list, built from the two maps above. */
  var COMMON = (function () { var h = Object.create(null), k; for (k in VAR_HERO) if (VAR_HERO[k]) h[VAR_HERO[k]] = true;
    return MEDIA_ORDER.slice(1).filter(function (id) { return !h[id]; }); })();

  var INITIAL_VARIANT = D.init;

  /* ---------------- helpers ---------------- */
  function Flk() {
    var F = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
    return (F && F.data) ? F : null;
  }
  var SS = document.querySelector('[data-product-slideshow]');

  var ALL = [];
  function cacheSlides() {
    if (ALL.length || !SS) return;
    SS.querySelectorAll('[data-media-slide]').forEach(function (el) {
      ALL.push({ id: String(el.getAttribute('data-media-id')), el: el });
    });
  }
  var THUMBS = [];
  function cacheThumbs() {
    if (THUMBS.length) return;
    document.querySelectorAll('[data-slideshow-thumbnail]').forEach(function (el) {
      THUMBS.push({ id: String(el.getAttribute('data-media-select')), el: el });
    });
  }

  /* The form is the truth. The URL is written later by the theme, so reading
     it first is what made this snippet and the thumbnail filter disagree. */
  function currentVariantId() {
    var el = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (el && el.value && VAR_HERO[String(el.value)]) return String(el.value);
    var p = new URLSearchParams(window.location.search);
    return p.get('variant') || INITIAL_VARIANT;
  }

  /* the variant's three images, in upload order */
  function tripleFor(heroId) {
    var i = MEDIA_ORDER.indexOf(String(heroId));
    if (i < 0) return null;
    var t = MEDIA_ORDER.slice(i, i + 3);
    return t.length === 3 ? t : null;
  }

  var lastVariant = null, pending = null;

  function doApply(variantId) {
    var heroId = String(VAR_HERO[String(variantId)] || '');
    if (!heroId) return;
    cacheSlides();
    cacheThumbs();
    if (!ALL.length) return;

    var F = Flk();
    var flkty = F ? F.data(SS) : null;
    if (!flkty) { pending = variantId; armReady(); return; }

    /* wanted ids: this variant's triple, else the old hero+commons behaviour */
    var wanted = tripleFor(heroId) || [heroId].concat(COMMON);
    var show = {};
    wanted.forEach(function (id) { show[id] = true; });

    var byId = {};
    ALL.forEach(function (s) { byId[s.id] = s; });
    var desired = [];
    wanted.forEach(function (id) { if (byId[id]) desired.push(byId[id]); });
    if (!desired.length) return;

    /* clear stale inline display so re-added cells aren't stuck hidden */
    ALL.forEach(function (s) { s.el.style.display = ''; });

    /* Upgrade the shown slides' images BEFORE swapping so the new hero is
       already decoded (no blur, no white gap). */
    desired.forEach(function (s) {
      s.el.querySelectorAll('img[data-fp-src]').forEach(function (img) {
        if (img.dataset.fpSrcset) img.srcset = img.dataset.fpSrcset;
        if (img.dataset.fpSrc) img.src = img.dataset.fpSrc;
        img.dataset.fpUpgraded = '1';
      });
    });

    var heroEl = desired[0].el;
    try {
      var current = flkty.getCellElements().slice();
      /* SWAP (no empty-frame flash): put the new hero in front and select it
         BEFORE removing the old cells, so the gallery never goes blank. */
      if (lastVariant && current.length && current.indexOf(heroEl) === -1) {
        flkty.insert([heroEl], 0);
        flkty.select(0, false, true);
        flkty.remove(current);
        flkty.append(desired.slice(1).map(function (s) { return s.el; }));
      } else {
        flkty.remove(current);
        flkty.append(desired.map(function (s) { return s.el; }));
        flkty.select(0, false, true);
      }
      flkty.resize();
    } catch (e) { if (window.console) console.warn('[int-vg-framed]', e); }

    /* Tell the section's repair pass that the cells changed.
       sections/product-framedprint.liquid re-applies the height clamp and the
       slide aspect ratios in onVIAFinalPass, armed by armVIASettleDetector. If
       nothing re-arms it after a swap, Flickity's viewport can settle at height
       0 and the main image disappears while the thumbnails look right.
       ⚑ `int:gallery:settled` is named after the removed VIA app but is still live
       theme plumbing: layout/theme.liquid fires it on load and on every
       colour-swatch fadein. What it never fires on is a Frame Size change —
       so the repair pass ran for colours and not for sizes. Firing it here
       covers both. */
    try {
      document.dispatchEvent(new CustomEvent('int:gallery:settled'));
      window.dispatchEvent(new Event('resize'));
    } catch (e) {}

    /* thumbnails: this variant's triple only. The theme forces display on
       thumbs with !important, so override with !important too. */
    THUMBS.forEach(function (t) {
      if (show[t.id]) t.el.style.removeProperty('display');
      else t.el.style.setProperty('display', 'none', 'important');
    });
    var thumbWrap = document.querySelector('[data-product-thumbs]')
                 || (THUMBS[0] && THUMBS[0].el.parentNode);
    if (thumbWrap) {
      var heroThumb = null;
      THUMBS.forEach(function (t) { if (t.id === heroId) heroThumb = t.el; });
      if (heroThumb && thumbWrap.firstChild !== heroThumb) {
        thumbWrap.insertBefore(heroThumb, thumbWrap.firstChild);
      }
    }

    /* preload the OTHER frame colours for THIS size so switching colour is
       instant (their slides are detached, but setting img.src still fetches). */
    try {
      var sizeVal = VAR_SIZE[String(variantId)];
      if (sizeVal) {
        var sizeHeroes = {};
        for (var vid in VAR_SIZE) {
          if (VAR_SIZE[vid] === sizeVal) sizeHeroes[String(VAR_HERO[vid])] = 1;
        }
        ALL.forEach(function (s) {
          if (!sizeHeroes[s.id]) return;
          s.el.querySelectorAll('img[data-fp-src]').forEach(function (img) {
            if (img.dataset.fpUpgraded) return;
            if (img.dataset.fpSrcset) img.srcset = img.dataset.fpSrcset;
            if (img.dataset.fpSrc) img.src = img.dataset.fpSrc;
            img.dataset.fpUpgraded = '1';
          });
        });
      }
    } catch (e) {}

    lastVariant = String(variantId);
  }

  function applyVariant(variantId, force) {
    if (!force && String(variantId) === lastVariant) return;
    doApply(variantId);
  }

  /* ---------------- ready handling + init watchdog ---------------- */
  /* ⚑ WATCHDOG, added 2026-08-20.
     assets/theme.js constructs Flickity EXACTLY ONCE and never retries:
     DOMContentLoaded -> load('*') -> ProductTemplate -> new Media(section) ->
     connectSliderMediaEvents() -> createDesktopSlider() -> new Flickity().
     There is no window.load fallback, no observer, no poll; shopify:section:load
     only re-inits in Shopify.designMode. So if that one handler is late or
     throws, the gallery is dead for the life of the page: every slide still in
     the DOM, no viewport, main image 0x0. Seen once in six cold loads
     (2026-08-19) and it never recovers without a reload.
     armReady used to give up after 80 x 100 ms and leave it exactly there.
     Now it waits 30 s, and from 6 s on it builds the slideshow itself with the
     theme's own options. A slow gallery beats a dead one. */

  var BOOT_AFTER_MS = 6000;   /* start building it ourselves */
  var RETRY_MS      = 2000;   /* and keep trying this often */
  var GIVE_UP_MS    = 30000;  /* stop polling */
  var wdBooted      = false;  /* true only when WE constructed the instance */

  /* Lifted verbatim from assets/theme.js Media#createDesktopSlider /
     #createMobileSlider (Pipeline 7.5.0), read off the live bundle 2026-08-20.
     Do not "tidy" these values and do not add a cellSelector - the theme passes
     none, so Flickity takes every child element. adaptiveHeight and wrapAround
     are flipped to false immediately afterwards by the instant-select patch in
     layout/theme.liquid, which runs whether or not theme.js ever did; they are
     left here exactly as the theme sets them. */
  function slideshowOptions() {
    var o = {
      autoPlay: false, prevNextButtons: false, pageDots: false,
      adaptiveHeight: true, accessibility: true, watchCSS: false,
      wrapAround: true, rightToLeft: window.isRTL, dragThreshold: 80,
      contain: true, fade: true
    };
    var medium = (window.theme && window.theme.sizes && window.theme.sizes.medium) || 768;
    var isMobile = window.matchMedia('(max-width: ' + medium + 'px)').matches;
    var style = isMobile
      ? (SS.getAttribute('data-slideshow-mobile-style') || '')
      : (SS.getAttribute('data-slideshow-desktop-style') || '');
    if (style === 'none') return null;   /* the theme builds no slider here */
    if (isMobile) {
      if (style === 'carousel') { o.contain = false; o.dragThreshold = 10; o.fade = false; }
      else if (style === 'slideshow') { o.pageDots = true; o.fade = false; o.dragThreshold = 10; }
    }
    return o;
  }

  /* Last resort, only when Flickity itself is unusable: show the first slide at
     natural size so the customer sees the picture instead of a 0x0 box. */
  function showFirstSlideRaw() {
    if (!SS) return;
    var slides = SS.querySelectorAll('[data-media-slide]');
    if (!slides.length || SS.getAttribute('data-int-vg-raw')) return;
    for (var i = 0; i < slides.length; i++) {
      slides[i].style.setProperty('display', i === 0 ? 'block' : 'none', 'important');
    }
    var first = slides[0];
    first.style.setProperty('position', 'relative', 'important');
    first.style.setProperty('width', '100%', 'important');
    first.style.setProperty('height', 'auto', 'important');
    first.style.setProperty('opacity', '1', 'important');
    first.querySelectorAll('img[data-fp-src]').forEach(function (img) {
      if (img.dataset.fpSrcset) img.srcset = img.dataset.fpSrcset;
      if (img.dataset.fpSrc) img.src = img.dataset.fpSrc;
      img.dataset.fpUpgraded = '1';
    });
    SS.setAttribute('data-int-vg-raw', '1');
  }
  function clearFirstSlideRaw() {
    if (!SS || !SS.getAttribute('data-int-vg-raw')) return;
    SS.querySelectorAll('[data-media-slide]').forEach(function (el) {
      el.style.removeProperty('display');
      el.style.removeProperty('position');
      el.style.removeProperty('width');
      el.style.removeProperty('height');
      el.style.removeProperty('opacity');
    });
    SS.removeAttribute('data-int-vg-raw');
  }

  /* If WE built the slideshow the theme's Media class never ran, so nothing is
     listening to the thumbnail rail. Wire the minimum so the rail still works.
     Bound once, and inert unless the watchdog actually fired. */
  var thumbsArmed = false;
  function armFallbackThumbs() {
    if (thumbsArmed) return;
    thumbsArmed = true;
    document.addEventListener('click', function (e) {
      if (!wdBooted) return;
      var t = e.target && e.target.closest && e.target.closest('[data-slideshow-thumbnail]');
      if (!t) return;
      var F = Flk(); var flkty = (F && SS) ? F.data(SS) : null;
      if (!flkty) return;
      var id = String(t.getAttribute('data-media-select'));
      var cells = flkty.getCellElements();
      for (var i = 0; i < cells.length; i++) {
        if (String(cells[i].getAttribute('data-media-id')) === id) {
          flkty.select(i, false, true);
          break;
        }
      }
    }, false);
  }

  /* Returns true once a usable instance exists - whoever built it. */
  function bootFlickity() {
    var F = Flk();
    if (!F || !SS) return false;
    if (F.data(SS)) return true;                              /* theme got there */
    if (SS.classList.contains('flickity-enabled')) return true; /* mid-construction */
    if (!SS.querySelector('[data-media-slide]')) return false;
    var opts = slideshowOptions();
    if (!opts) return false;
    try {
      clearFirstSlideRaw();
      new F(SS, opts);
      wdBooted = true;
      armFallbackThumbs();
      if (window.console) {
        console.warn('[int-vg-framed] theme.js never initialised the slideshow - watchdog built it');
      }
      try {
        document.dispatchEvent(new CustomEvent('int:gallery:settled'));
        window.dispatchEvent(new Event('resize'));
      } catch (e) {}
      return true;
    } catch (e) {
      if (window.console) console.warn('[int-vg-framed] watchdog boot failed', e);
      return false;
    }
  }

  /* ⛑ Measure the wait on the WALL CLOCK, never by counting ticks. Chrome
     throttles setInterval in a background tab to roughly 1 Hz, so the old
     "80 x 100 ms = 8 s" ceiling was really 80 s there - and a tick-counted 6 s
     watchdog silently became a minute. Measured 2026-08-20 on this very page:
     2 ticks in 3000 ms. */
  var readyTimer = null, armedAt = 0, lastBootTry = 0;
  function armReady() {
    if (readyTimer) return;
    armedAt = Date.now();
    lastBootTry = 0;
    readyTimer = setInterval(function () {
      var F = Flk();
      if (F && SS && F.data(SS)) {
        clearInterval(readyTimer); readyTimer = null;
        applyVariant(pending || currentVariantId(), false);
        pending = null;
        return;
      }
      var waited = Date.now() - armedAt;
      if (waited >= BOOT_AFTER_MS && (Date.now() - lastBootTry) >= RETRY_MS) {
        lastBootTry = Date.now();
        if (!bootFlickity()) showFirstSlideRaw();
      }
      if (waited > GIVE_UP_MS) { clearInterval(readyTimer); readyTimer = null; }
    }, 100);
  }

  /* ---------------- events ---------------- */
  function onVariantEvent(e) {
    var v = e && e.detail && e.detail.variant;
    applyVariant(v && v.id ? String(v.id) : currentVariantId());
  }
  document.addEventListener('variant:change', onVariantEvent);
  document.addEventListener('theme:variant:change', onVariantEvent);

  /* React to the control itself as well, on the same signals the thumbnail
     filter uses — the theme's variant event and URL both arrive late, and
     waiting for them is what let the rail and the slideshow drift apart. */
  function nudge() {
    var t0 = Date.now();
    var iv = setInterval(function () {
      var id = currentVariantId();
      if (id !== lastVariant) applyVariant(id);
      if (Date.now() - t0 > 2500) clearInterval(iv);
    }, 120);
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.int-gswatch')) nudge();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.id === 'int-gallery-framesize-select' ||
                     (e.target.name && e.target.name === 'id'))) nudge();
  }, true);

  /* Arm the watchdog on every load, not only when doApply happens to reach the
     "no Flickity yet" branch - doApply returns early if the media map or the
     slide list is not ready, and that used to leave nothing watching at all. */
  function boot() {
    applyVariant(currentVariantId(), true);
    armReady();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
